/**
 * src/lib/stripe.js — shared Stripe.js loader.
 *
 * `loadStripe` injects a script tag and must not be called on every render —
 * doing so refetches Stripe.js and can remount an already-mounted Element,
 * wiping anything the client has typed. Cached here, keyed by publishable
 * key, so every embedded payment form on the page — deposits
 * (PaymentForm.jsx) and the platform subscription
 * (SubscriptionPaymentForm.jsx) alike — share one Stripe.js instance per key
 * instead of each loading its own.
 */
import { loadStripe } from '@stripe/stripe-js';

/** @type {Map<string, Promise<import('@stripe/stripe-js').Stripe|null>>} */
const stripeCache = new Map();

/**
 * @param {string} publishableKey
 * @returns {Promise<import('@stripe/stripe-js').Stripe|null>}
 */
export function getStripe(publishableKey) {
  if (!stripeCache.has(publishableKey)) {
    stripeCache.set(publishableKey, loadStripe(publishableKey));
  }
  return stripeCache.get(publishableKey);
}
